export default [
  {
    policyName: 'National Defense Authorization Act for Fiscal Year 2025',
    policySummary: 'Authorization of FY 2025 appropriations for the Department of Defense',
    policyCode: 'POLICY-CODE-0001',
  },
  {
    policyName: 'NIST SP 800-171',
    policySummary: 'Recommended requirements for safeguarding CUI outside of federal systems and organizations',
    policyCode: 'POLICY-CODE-0002',
  },
  {
    policyName: 'NIST SP 800-53',
    policySummary: 'Catalog of security and privacy controls for protecting systems & information',
    policyCode: 'POLICY-CODE-0003',
  },
  {
    policyName: 'Cybersecurity Maturity Model Certification',
    policySummary: 'The Cybersecurity Maturity Model Certification framework is designed to enforce the protection of shared sensitive information',
    policyCode: 'POLICY-CODE-0004',
  },
  {
    policyName: 'Modernizing Defense Acquisitions and Spurring Innovation in the Defense Industrial Base',
    policySummary: 'Executive order mandating reform of the defense acquisition system.',
    policyCode: 'POLICY-CODE-0005',
  },
  {
    policyName: 'Restoring Common Sense to Federal Procurement',
    policySummary: 'Executive order mandating wholistic revisions to the Federal Acquisition Regulation (FAR).',
    policyCode: 'POLICY-CODE-0006',
  },
  {
    policyName: 'Ensuring Commercial, Cost-Effective Solutions in Federal Contracts',
    policySummary: 'Executive order aimed at streamlining federal procurement processes by prioritizing the use of existing commercial solutions over custom or commercially unavailable solutions.',
    policyCode: 'POLICY-CODE-0007',
  },
];